import {
  useCallback,
  useState,
} from 'react';
import { DropdownComponent } from '~/_shared/baseComponents/dropdown';
import type { useBTGFillData } from '../hooks/useBTGFillData';
import { ActiveBoundaryDropdownOptionComponent } from './activeBoundaryDropdownOption.component';
import { ActiveBoundaryDropdownTriggerComponent } from './activeBoundaryDropdownTrigger.component';
import {
  headerDropdownContentStyle, headerWrapperStyle, interactiveHeaderWrapperStyle, mainHeaderStyle,
} from './styles';

export type ActiveBoundaryFillDropdownProps = Pick<
  ReturnType<typeof useBTGFillData>,
  'allowFillChange' | 'setActiveBTGId' | 'activeBTGOption' | 'filteredBTGDropDownOptions' | 'isOnlyNofillOption'
>;

export const ActiveBoundaryFillHeader = ({
  isLegendMode,
  dropdownProps: {
    allowFillChange,
    activeBTGOption,
    filteredBTGDropDownOptions,
    setActiveBTGId,
    isOnlyNofillOption,
  },
}: Readonly<{
  dropdownProps: ActiveBoundaryFillDropdownProps;
  isLegendMode?: boolean;
}>) => {

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const canChangeFill = (filteredBTGDropDownOptions.length > 0) && !isLegendMode && allowFillChange;

  const closeDropdown = useCallback(() => {
    setIsDropdownOpen(false);
  }, []);

  const toggleDropdown = useCallback(() => {
    setIsDropdownOpen(status => !status);
  }, []);

  return (
    <>
      {!isOnlyNofillOption && (
        <div
          css={[
            headerWrapperStyle,
            mainHeaderStyle,
            canChangeFill ? interactiveHeaderWrapperStyle : undefined,
          ]}
        >
          <DropdownComponent
            css={headerDropdownContentStyle}
            inPortal
            isOpen={allowFillChange && isDropdownOpen}
            triggerComponent={activeBTGOption && (
              <ActiveBoundaryDropdownTriggerComponent
                {...activeBTGOption}
                onClick={
                  canChangeFill
                    ? toggleDropdown
                    : undefined
                }
              />
            )}
            onClose={closeDropdown}
          >
            {filteredBTGDropDownOptions.map(btgOption => {
              if (!btgOption) {
                return null;
              }
              return (
                <ActiveBoundaryDropdownOptionComponent
                  key={btgOption.boundaryTerritoryGroup.boundaryTerritoryGroupId}
                  {...btgOption}
                  onClick={() => setActiveBTGId(btgOption.boundaryTerritoryGroup)}
                />
              );
            })}
          </DropdownComponent>
        </div>
      )}
    </>
  );
};
